export default "__VITE_ASSET__C3LRjFz1__"